import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { features } from '../mock';

const FeaturesManifesto = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section ref={ref} className="py-32 bg-slate-900 relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#4f4f4f08_1px,transparent_1px),linear-gradient(to_bottom,#4f4f4f08_1px,transparent_1px)] bg-[size:6rem_6rem]" />
      
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-24"
        >
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Teknologi <span className="bg-gradient-to-r from-emerald-400 to-blue-400 bg-clip-text text-transparent">Terbukti</span>
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto">
            Kami memberikan layanan monitoring canggih yang didukung oleh keahlian teknis WhaTap yang tak tertandingi
          </p>
        </motion.div>

        <div className="max-w-5xl mx-auto space-y-24">
          {features.map((feature, index) => (
              <motion.div
                key={feature.number}
                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="relative"
              >
                <div className="flex flex-col md:flex-row gap-8 items-start">
                  {/* Number */}
                  <motion.div
                    whileHover={{ scale: 1.1, rotate: 5 }}
                    className="relative"
                  >
                    <div className="text-8xl md:text-9xl font-bold bg-gradient-to-br from-emerald-500 to-blue-500 bg-clip-text text-transparent opacity-20">
                      {feature.number}
                    </div>
                    <div className="absolute inset-0 text-8xl md:text-9xl font-bold text-white mix-blend-overlay">
                      {feature.number}
                    </div>
                  </motion.div>

                  {/* Content */}
                  <div className="flex-1 pt-4">
                    <h3 className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight">
                      {feature.title}
                    </h3>
                    <p className="text-lg text-slate-400 leading-relaxed">
                      {feature.description}
                    </p>

                    {/* Decorative line */}
                    <motion.div
                      initial={{ width: 0 }}
                      whileInView={{ width: "100%" }}
                      viewport={{ once: true }}
                      transition={{ duration: 1, delay: 0.5 }}
                      className="mt-6 h-0.5 bg-gradient-to-r from-emerald-500 to-transparent"
                    />
                  </div>
                </div>
              </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesManifesto;
